export const HTTP_METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
};
export const ACTING_ENTITY_HEADER = 'x-acting-entity';
